// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"838c73dd","239":"6de977c1","453":"8f6ccddb","667":"5cb04dcb"}[chunkId] + ".chunk.js";
};